import React from 'react'
import './App.css'
import Amplify from 'aws-amplify'
import { AmplifyAuthenticator, AmplifyConfirmSignUp, AmplifySignIn, AmplifySignUp } from '@aws-amplify/ui-react'
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components'
import { Auth } from '@aws-amplify/auth'
import jwt from 'jwt-decode'
import awsconfig from './aws-exports'
import Button from 'react-bootstrap/Button'
import ClinicianPortal from './components/ClinicianPortal'
import {getLoggedInToken, clearIdToken, clinicianIdFromRefreshAuth, ROLE_NAME, ROLES} from './util/authUtil'
import { Hub } from 'aws-amplify'
import ApiService from './ApiService'

Amplify.configure(awsconfig)

Auth.configure(awsconfig)

let once = 0

const AuthStateApp = () => {
  const [authState, setAuthState] = React.useState(null)
  const [user, setUser] = React.useState(null)
  const [isUserHasPermission, setIsUserHasPermission] = React.useState(false)

  const extractUserGroups = sess => {
    const sessionIdInfo = jwt(sess.getIdToken().jwtToken)
    return sessionIdInfo['cognito:groups']
  }

  const isUserHasRolePermission = (userGroups) => {
    if(userGroups === undefined || userGroups === null || userGroups?.length === 0) {
      return false;
    }
    if(userGroups.some(role => ROLES.includes(role))){
      return true;
    }
    return false;
  };

  const logout = event => {
    Auth.signOut()
      .then(() => {
        clearIdToken();
        localStorage.clear();
      })
      .catch(err => {
        event.stopPropagation();
        console.error(err);
        localStorage.clear();
      })
  }

  React.useEffect(() => {
    return onAuthUIStateChange((nextAuthState, authData) => {
      setAuthState(nextAuthState)
      setUser(authData)
    })
  }, [])

  //$ Style Overrides for this page
  React.useEffect(() => {
    document.body.style.background = '#FDFAF1';
  }, [])

  React.useEffect(() => {
    if (authState === AuthState.SignedIn && user) {
      Auth.currentSession()
        .then(sess => {
          getLoggedInToken().then(r => r)
          const groups = extractUserGroups(sess)
          if (isUserHasRolePermission(groups)) {
            setIsUserHasPermission(true)
          }
          return true
        })
        .catch(err => {
          return false
        })
    }
  }, [authState, user])

  //$ Add Profile Signup for Clinician on Signup
  const addUser = async user => {
    try {
      const response = await ApiService.addClinicianProfileOnSignup(user)
    } catch (error) {
      console.log(error);
    }
  }

  React.useEffect(() => {
    Hub.listen('auth', data => {
      switch (data.payload.event) {
        case 'signIn':
          break;
        case 'signUp':
          if (once === 0) {
            once = once + 1
            addUser({
              id: data.payload.data.userSub,
              email: data.payload.data.user.username,
            }).then(r => r);
          }
          break;
        case 'signOut':
          console.log('user signed out');
          localStorage.clear();
          break
        case 'signIn_failure':
          console.log('user sign in failed')
          break
        case 'configured':
          console.log('the Auth module is configured')
          break
        default:
          console.log('default')
      }
    })
  }, [])


  if (isUserHasPermission && user) {
    return (
      <div className="App">
          <ClinicianPortal user={user} />
      </div>
    );
  } else if (authState === AuthState.SignedIn && user) {
    return (
      <div className="App">
        <div>Welcome to team TBD. Your clinician account is being reviewed. When you are verified, you will receive an email notification.</div>
        <Button variant={'outline-info'} onClick={logout}>
          Logout
        </Button>
      </div>
    )
  } else if (authState === AuthState.ConfirmSignUp) {
    return (
      <AmplifyAuthenticator usernameAlias="email">
        <AmplifyConfirmSignUp slot="confirm-sign-up" usernameAlias="email" />
      </AmplifyAuthenticator>
    )
  } else {
    return (
      <AmplifyAuthenticator usernameAlias="email">
        <AmplifySignUp
          slot={'sign-up'}
          usernameAlias="email"
          formFields={[
            {
              label: 'First Name',
              type: 'given_name',
              placeholder: 'Susan',
              required: true,
            },
            {
              label: 'Last Name',
              type: 'family_name',
              placeholder: 'Smith',
              required: true,
            },
            {
              type: 'email',
              placeholder: 'susan.smith@tbd.health',
              required: true,
            },
            {
              type: 'password',
              placeholder: '***************',
              required: true,
            },
            {
              type: 'phone_number',
              placeholder: '234-567-8901',
              required: true,
            },
          ]}
        />
        <AmplifySignIn slot="sign-in" usernameAlias="email" />
      </AmplifyAuthenticator>
    )
  }
}

export default AuthStateApp
